module.exports = __webpack_public_path__ + "assets/img/rdn.e975ecc8.png";